export default "__VITE_ASSET__DYpGQzAp__"